import { DatePicker } from "antd";
import { DateInputProps } from "../../types/common";
import dayjs from "dayjs";

export const DateInput = (props: DateInputProps) => {
  const {
    value,
    disabledDate,
    onChange,
    required,
    minDate,
    maxDate,
    disablePast,
    disableFuture,
    ...rest
  } = props;

  const combinedDisabledDate = (current: any) => {
    if (!current) return false;

    let disabled = false;

    if (disabledDate) {
      disabled = disabledDate(current);
    }

    if (minDate && current.isBefore(dayjs(minDate), "day")) {
      disabled = true;
    }

    if (maxDate && current.isAfter(dayjs(maxDate), "day")) {
      disabled = true;
    }

    if (disablePast && current.isBefore(dayjs(), "day")) {
      disabled = true;
    }

    if (disableFuture && current.isAfter(dayjs(), "day")) {
      disabled = true;
    }

    return disabled;
  };

  return (
    <DatePicker
      onChange={(date: any) => onChange(date)}
      value={value}
      style={{ width: "100%" }}
      getPopupContainer={(): HTMLElement => document.body}
      popupStyle={{ zIndex: 1400 }}
      disabledDate={combinedDisabledDate}
      required={required}
      {...rest}
    />
  );
};
